import React from 'react';
import {COLORS, Image, SIZES, Typography} from '@fupa/fupa-uikit';
import {getTeamName} from 'app/helpers/getTeamName';
import MatchResult from 'app/components/match/liveResult/MatchResult';
import styled from 'styled-components';
import {StoreResultResponse} from 'app/components/match/liveResult/types';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 6.75rem 1fr;
  justify-items: center;
  min-height: ${SIZES['42']};
`;

const Team = styled.div`
  display: grid;
  justify-items: center;
  justify-content: center;
  align-content: start;
`;

const TeamName = styled(Typography)`
  &&& {
    color: ${COLORS.black};
  }
  display: block;
  line-height: ${SIZES['24']};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  white-space: nowrap;
`;

interface UpdateResultHeaderProps {
  match: any;
  resultData: StoreResultResponse | null;
}

export default function UpdateResultHeader({match, resultData}: UpdateResultHeaderProps) {
  return (
    <Container>
      <Team>
        <Image entity='emblem' height={64} width={64} src={match.homeTeam.image} fit={true} alt={match.homeTeamName} />
        <TeamName variant='subheading2' component='span'>
          {getTeamName(match.homeTeam.name.middle, match.homeTeam.level)}
        </TeamName>
      </Team>
      <MatchResult data={resultData} />
      <Team>
        <Image entity='emblem' height={64} width={64} src={match.awayTeam.image} fit={true} alt={match.awayTeamName} />
        <TeamName variant='subheading2' component='span'>
          {getTeamName(match.awayTeam.name.middle, match.awayTeam.level)}
        </TeamName>
      </Team>
    </Container>
  );
}
